export const COLUMN = {
  DEFAULT: 'DEFAULT',
  HOME_CHECK_IN_COMPLETED: 'HOME_CHECK_IN_COMPLETED',
  CHECK_IN_COMPLETED: 'CHECK_IN_COMPLETED',
  IN_HOUSE: 'IN_HOUSE',
  CHECK_OUT_READY: 'CHECK_OUT_READY',
  CHECK_OUT_COMPLETED: 'CHECK_OUT_COMPLETED',
};

export const COMPLETED_COLUMNS = [
  COLUMN.CHECK_OUT_COMPLETED,
  COLUMN.CHECK_IN_COMPLETED,
];

export const SELF_SERVICE_KANBAN_STATUS_TO_COLUMN = {
  WORK_FINISHED: COLUMN.CHECK_OUT_READY
};
